import React from "react";
import { loadCallback } from "../../../utils";
import { P_Props } from "./SimpleModalHeader.type";
import { Close as CloseIcon } from "@material-ui/icons";

const SimpleModalHeaderPresenter: React.FC<P_Props> = (props) => {
  return (
    <div className="simple-modal-header">
      <div className="simple-modal-header__title">{props.title}</div>
      {props.onClose && (
        <button
          className="simple-modal-header__close"
          onClick={() => {
            loadCallback(props.onClose);
          }}
          style={{ marginRight: "2.6rem" }}
        >
          <CloseIcon style={{ fontSize: "2.2rem" }} />
        </button>
      )}
    </div>
  );
};

export default SimpleModalHeaderPresenter;
